import { CONFIG } from '../config';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.logo}>
        {CONFIG.siteName.slice(0, 4)}
        <span>{CONFIG.siteName.slice(4)}</span>
      </div>
      <ul className={styles.links}>
        {CONFIG.footerLinks.map((link) => (
          <li key={link.label}>
            <a href={link.href}>{link.label}</a>
          </li>
        ))}
      </ul>
      <div className={styles.copy}>© 2025 {CONFIG.siteName} · Built on Base 🔷</div>
    </footer>
  );
}
